export enum ChannelStatus {
    PAUSED = 'PAUSED',
    COMPLETED = 'COMPLETED',
    LIVE = 'LIVE',
    DRAFT = 'DRAFT',
    PENDING_APPROVAL = 'PENDING_APPROVAL',
    PENDING_REAPPROVAL = 'PENDING_REAPPROVAL',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    CANCELLED = 'CANCELLED'
}

export const PendingStatuses: ChannelStatus[] = [
    ChannelStatus.PENDING_APPROVAL,
    ChannelStatus.PENDING_REAPPROVAL
];

export const approvedChannelStatuses: ChannelStatus[] = [
    ChannelStatus.APPROVED,
    ChannelStatus.LIVE,
    ChannelStatus.COMPLETED,
    ChannelStatus.PAUSED
];
